module.exports = __webpack_public_path__ + "static/media/star-unselected.c9d01998.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/star-unselected.svg
// module id = 3786
// module chunks = 0